<script>
  import {getQuery} from './utils';

  export default {
    data() {
      return {
        isOn: 1,
        editable: getQuery('dataset') == 'mnist',
        disabled: false
      }
    },
    components: {
      Editable: './Editable.html',
      Slider: './Slider.html'
    },
    computed: {
      isOff: ({ isOn }) => {
        return !isOn;
      }
    },
    methods: {
      selectValue(value, node, i) {
        for (let j = 0; j < node.flat.options.length; j++)
          value[node.flat.index+j] = 0;
        value[node.flat.index+i] = 1;
        for (let k = 0; k < node.options[i].length; k++) {
          const sub = node.options[i][k];
          if (sub.type == "categorical") {
            value = this.selectValue(value, sub, 0);
          }
        }
        return value;
      },
      selectDisc(node, option) {
        let { value } = this.get();
        const optionIndex = option.index;
        const i = optionIndex - node.flat.index;
        this.fire('select', {
          dim: node.flat,
          val: i
        });
        this.set({ value: this.selectValue(value, node, i) });
      }
    }
  }
</script>

<style>
.slider {
  padding-top: var(--gutter-sm);
  white-space: nowrap;
}
.subhierarchy {
  margin-top: calc(2 * var(--gutter-sm));
}
input[type="radio"] {
  transform: scale(1.5);
}
select {
  width: auto;
}
ul {
  padding: 0;
  list-style: none;
  margin-top: 0;
  margin-bottom: 1rem;
}
ul.slider-group {
  float: left;
  width: calc(100% - 2rem - 5px);
}
.inactive {
  display: none;
}
</style>

<div class='slider-group-wrapper clearfix' class:active=isOn class:inactive=isOff>

  <ul class='slider-group'>
    {#each hierarchy as node, i (node.flat.index)}
      <li class='slider'>
        {#if node.type == 'continuous'}
          {#if editable}
            <Editable bind:value=$contDims[node.flatIdx].name fieldId={$contDims[node.flatIdx].id} />:
          {:else}
            <code>{$contDims[node.flatIdx].name}</code>:
          {/if}
          <Slider bind:value=value[node.flat.index]
            min={$z_lims[node.flatIdx][0]}
            max={$z_lims[node.flatIdx][1]}
            dim={node.flat}
            disabled={disabled}
            on:slide
            on:release
          />
        {:else}
          {#if editable}
            <Editable bind:value=$discDims[node.flatIdx].name fieldId={$discDims[node.flatIdx].id} />:
          {:else}
            <code>{$discDims[node.flatIdx].name}</code>:
          {/if}
          <!--<select class='custom-select custom-select-sm' on:change="select(node,this)">-->
            <!--{#each $discDims[node.flatIdx].options as option, j (j)}-->
              <!--<option value={option.index} selected={value[node.flat.index+j]==1}>{option.name}</option>-->
            <!--{/each}-->
          <!--</select>-->

          <span class='buttons'>
            {#each $discDims[node.flatIdx].options as option, j (j)}
              <input
                type='radio'
                name={node.flat.index}
                value={option.index}
                checked={value[node.flat.index+j]==1 ? "checked" : ""}
                on:change=selectDisc(node,option)
              />
            {/each}
          </span>

          {#each node.options as option, j (j)}
                <!--<Editable bind:value=$discDims[node.flatIdx].options[j].name fieldId={$discDims[node.flatIdx].options[j].id}/> sub-dimensions:-->
            {#if option.length}
              <div class='subhierarchy'>
                <svelte:self hierarchy={option} isOn={isOn * value[node.flat.index + j]} bind:value=value editable={editable} disabled={disabled} />
            
              </div>
            {/if}
          {/each}
        {/if}
      </li>
    {/each}
  </ul>
</div>
